import { render, staticRenderFns } from "./logger-levels-config.vue?vue&type=template&id=765c8771"
import script from "./logger-levels-config.vue?vue&type=script&lang=js"
export * from "./logger-levels-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports